/**
 * API base URL based on REACT_APP_ENV:
 * - dev    → https://api.dev.babybillion.in
 * - prod   → https://api.babybillion.in
 * - local  → http://127.0.0.1:5001 (overridden per route for testing)
 */
const env = (process.env.REACT_APP_ENV || 'dev').toLowerCase();

const baseUrls = {
  dev: 'https://api.dev.babybillion.in',
  prod: 'https://api.babybillion.in',
  local: 'http://127.0.0.1:5001',
};

const explicitBase = (process.env.REACT_APP_API_BASE_URL || '').trim();

// Always use full API URL (no proxy). To avoid CORS, your API must allow your app origin (e.g. http://localhost:3000).
export const API_BASE_URL = explicitBase || baseUrls[env] || baseUrls.dev;

/** When true, login uses dummy pass-through if the API fails (for local testing). */
export const isLocalEnv = env === 'local';

export function apiUrl(path) {
  let base = API_BASE_URL;

  // For local testing, allow different backends based on the API path itself:
  // - /cms/admin/*   → http://127.0.0.1:5005
  // - /user/admin/*  → http://127.0.0.1:5001
  // - /admin/payment/* or /payments* → http://127.0.0.1:5003
  if (env === 'local') {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    if (normalizedPath.startsWith('/cms/admin')) {
      base = 'http://127.0.0.1:5005';
    } else if (normalizedPath.startsWith('/user/admin')) {
      base = 'http://127.0.0.1:5001';
    } else if (normalizedPath.startsWith('/admin/payment') || normalizedPath.startsWith('/payments')) {
      base = 'http://127.0.0.1:5003';
    }
  }

  base = base.replace(/\/$/, '');
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${base}${p}`;
}
